/**
 * @param {Object} state State
 * @returns {Object}
 */var getBase=function getBase(state){return state.account;};/**
 * @param {Object} state State
 * @returns {Array}
 */export var getCustomer=function getCustomer(state){return getBase(state).customer.data;};